import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ProcedurePageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/mobile/pages/Procedure"
    ),
  loading: LoadableLoading
});
const ProcedurePageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/desktop/pages/Procedure"
    ),
  loading: LoadableLoading
});

class Procedure extends Component {
  render() {
    const info = get(partnerInfo, "menu");
    const procedureInfo = find(info, { key: "quy-trinh" });
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <ProcedurePageMobile procedureInfo={procedureInfo} />
        ) : (
          <ProcedurePageDesktop procedureInfo={procedureInfo} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    }
  } = state;
  return {
    device: type
  };
};

const ProcedureHelmet = withTitle({
  component: Procedure,
  title: `${hospitalName.value} | Quy trình đăng ký khám bệnh`
});

export default connect(mapStateToProps)(ProcedureHelmet);
